<template>
  <div style="height: 100%; overflow: auto;">
    <ul class="infinite-list chart-main">
      <li
        v-for="(v, k) in messageList"
        :key="k"
        :style="'margin:2px 0px;padding: 3px 10px; background-color:' + (v.from.type === 1 ? '#d3e0f1' : '#d3e8e8')"
      >
        <span style="font-weight: bold">{{(v.from.type === 1 || v.from.type === 7) ? '用户' : 'AI' }}</span>
        {{ v.to.type === 0 ? "" : (v.from.type === 1 && v.to.type !== 0 && v.subject === "text" ? ('(' + ((v.marks || []).indexOf('replied') >= 0 ? '已回复' : '未回复' ) + ')') : '') }}
        <span
          style="font-size: 12px;"
        >({{ getDisplayTime(v.time) }})：</span>
        <span v-if="v.subject === 'text'">
          {{ v.body.message }}
          <el-button
            v-if="isShowFaq(v)"
            size="mini"
            type="primary"
            @click="faqMessage(v.body.message)"
          >FAQ</el-button>
        </span>
        <span v-if="v.subject === 'answer'">{{ "[答题] " + v.body.id + ": " + v.body['answer'] }}</span>
        <span v-if="v.subject === 'choice'">{{ "[选择] " + JSON.stringify(v.body) }}</span>
        <span v-if="v.subject === 'script'">
          [剧场脚本]
          <span v-for="(x,y) in v.body.actions" :key="y">
            <span v-if="x.persistent">
              <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span>{{ formatAction(x) }}</span>
            </span>
          </span>
        </span>
      </li>
    </ul>
  </div>
</template>
<script>
import WS from '../../../api/ws'

export default {
    name: 'CustomServiceMessage',
    props: {
        messageList: {
            type: Array,
            default: () => [],
        },
        userId: {
            type: Number,
            default: 0,
        },
    },
    watch: {
        messageList: function() {
            let container = this.$el
            if (container.scrollHeight - (container.scrollTop + container.clientHeight) < 100) {
                setTimeout(() => {
                    container.scrollTop = container.scrollHeight + 50
                }, 50)
            }
        },
    },
    methods: {
        getDisplayTime(tm) {
            return tm
        },
        faqMessage: function(msg) {
            this.$emit('userMessage', { uid: this.userId, message: msg })
        },
        isShowFaq: function(msg) {
            return msg.from.type === WS.Role.user
        },
        formatAction(a) {
            let txt = a.data.desc || a.data.desc || a.data.text || ''
            return a.type + (txt ? ': ' + txt : '')
        },
    },
}
</script>
<style>
.is-vertical {
    display: flex;
    flex-direction: column;
    /* text-align: center; */
    height: 100%;
}

.chart-main {
    text-align: left;
    background-color: #e9eef3;
    color: #333;
    list-style: none;
    padding: 0;
    overflow: hidden;
}

.chat-input-container {
    background-color: #d3e8e8;
    color: #333;
    text-align: center;
    line-height: 60px;
}
</style>
